import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../Button";

class AddModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      creating: false,
    };

    this.form = React.createRef();

    this.toggleModal = this.toggleModal.bind(this);
    this.submit = this.submit.bind(this);
  }

  toggleModal() {
    this.props.onModalClose();
  }

  submit(){
    this.form.current.onSubmit()
  }

  render() {
    const {creating} = this.state;

    return <Modal isOpen={true} size={this.props.modalSize}>
      <ModalHeader toggle={this.toggleModal}>Dodaj</ModalHeader>
      <ModalBody>
        <this.props.form
          searchText={this.props.searchText}
          onCreated={manufacturer => this.props.onAdded(manufacturer)}
          ref={this.form}
          submitButton={false}
          onSavingStart={() => this.setState({ creating: true })}
          onSavingStop={() => this.setState({ creating: false })}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={this.toggleModal}>Anuluj</Button>
        <Button
          loading={creating}
          onClick={this.submit}
        >Utwórz</Button>
      </ModalFooter>
    </Modal>;
  }
}

AddModal.defaultProps = {
  modalSize: 'lg',
  searchText: '',
};

AddModal.propTypes = {
  searchText: PropTypes.string,
  modalSize: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl']),
  onModalClose: PropTypes.func.isRequired,
  onAdded: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

export default AddModal;
